import { Checkbox as AntCheckbox } from 'antd';
import styled from 'styled-components';

const Checkbox = styled(AntCheckbox)`
  .ant-checkbox-inner {
    transform: scale(1.125);
  }
`;

export { Checkbox };
